export let LoadingStatusActionTypes;
(function (LoadingStatusActionTypes) {
  LoadingStatusActionTypes["SetLoadingStatus"] = "[Loading] Set Loading Status";
  LoadingStatusActionTypes["ClearLoadingStatus"] = "[Loading] Clear Loading Status";
  LoadingStatusActionTypes["ClearAnyLoading"] = "[Loading] Clear Any Loading";
  LoadingStatusActionTypes["CopyCarouselFinished"] = "[Loading] Copy Carousel Finished";
})(LoadingStatusActionTypes || (LoadingStatusActionTypes = {}));